/***
 * @file:
 * @author: caojianping
 * @Date: 2021-05-24 16:42:23
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

import { PagesTabComponent } from './pages-tab.component';

const ANGULAR_MODULES = [CommonModule, RouterModule];

const THIRD_MODULES = [TranslateModule];

const ANTD_MODULES = [NzDropDownModule, NzMenuModule, NzIconModule, NzTabsModule, NzToolTipModule];

@NgModule({
  imports: [...ANGULAR_MODULES, ...THIRD_MODULES, ...ANTD_MODULES],
  declarations: [PagesTabComponent],
  exports: [PagesTabComponent],
})
export class DtPagesTabModule {}
